import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { GeraeteModell } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { GeraeteModelEdit } from "../../Controlls/EditViews/GeraeteModelEdit";
import { PopUpView } from "../../../Componente/PopUpView";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, GeraeteModelEdit, PopUpView
  ],
  selector: 'GeraetModell',
  templateUrl: './GeraetModell.html',
  standalone: true,
  styleUrl: './GeraetModell.css'
})
export class GeraetModell {
  @ViewChild('Grid') childComponent!: DataGridView<GeraeteModell>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
